import { useContext, useEffect } from 'react';
import { Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';
import HireMe from './components/HireMe';
import Loader from './components/Loader';
import MainBody from './components/MainBody';
import MyPlansModal from './components/MyPlansModal';
import MotoMateModal from './components/MotoMateModal';
import Navbar from './components/Navbar';
import Page404 from './components/Page404';
import TnC from './components/TnC';
import { Context } from './context/SharedState';
import './CSS/googleFonts.css';
import './CSS/loader.css';
import PrivacyPolicy from './MotoMate/components/PrivacyPolicy';
import DeleteAccountRequest from './MotoMate/components/DeleteAccountRequest';

function AppContent() {
  const location = useLocation();
  const { loading } = useContext(Context);

  // Define routes where Navbar should be hidden
  const hideNavbarRoutes = ['/motomate/privacy-policy', '/motomate/delete-account-request'];
  const shouldHideNavbar = hideNavbarRoutes.includes(location.pathname);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.location.hash && window.location.hash !== '#') {
        window.history.replaceState(null, null, window.location.pathname);
      }
    });
  }, []);

  if (loading) return <Loader />;

  return (
    <>
      {!shouldHideNavbar && <Navbar />}
      <MyPlansModal />
      <MotoMateModal />
      <Routes>
        <Route exact path="/" element={<MainBody />} />
        <Route exact path="/myplans/:id" element={<HireMe />} />
        <Route exact path="/terms" element={<TnC />} />
        <Route exact path="/motomate/privacy-policy" element={<PrivacyPolicy />} />
        <Route exact path="/motomate/delete-account-request" element={<DeleteAccountRequest />} />
        <Route path="*" element={<Page404 />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
